import React from 'react';
import { useEffect, useState } from 'react';
import { App } from 'jitsi/app/components/App.web';
import * as IISightAPI from 'common/helpers/api';
import { isWebview } from 'common/helpers/isWebview';
import { Loading } from '../Loading';
import { NotFound } from '../NotFound';
import { WaitingRoom } from '../WaitingRoom';
import { WebviewError } from '../WebviewError';
import { useTranslation } from 'react-i18next';
import { SALE_TEAM_TR, SALE_TEAM_EN } from 'config';
import { translateToHTML } from 'jitsi/base/i18n/functions';
import { sendLog } from 'common/helpers/api';
import 'react-tabs/style/react-tabs.css';
import { getMeetingData } from './requests/getMeetingData';
import i18next, { DEFAULT_LANGUAGE } from 'jitsi/base/i18n/i18next';
const MeetingPage = (props) => {
    const { user } = props;
    const { t } = useTranslation();
    let [, organisation, roomName] = location.pathname.split('/');
    let isPersonalRoom = false;
    if (organisation === 'r') {
        isPersonalRoom = true;
        organisation = null;
    }
    const [isStarted, setIsStarted] = useState(false);
    const [room, setRoom] = useState(null);
    const [webviewError, setWebviewError] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const callUrl = localStorage.getItem('language') === 'tr' && SALE_TEAM_TR ? SALE_TEAM_TR : SALE_TEAM_EN;
    const appName = interfaceConfig.APP_NAME;
    const deviceLanguage = navigator.language || DEFAULT_LANGUAGE;
    useEffect(() => {
        i18next.changeLanguage(deviceLanguage);
    }, []);
    const meetingStarted = async () => {
        try {
            const { data: { status }, } = await IISightAPI.checkMeetingIsStarted(roomName, organisation);
            const data = { organisationSlug: organisation, roomSlug: roomName, res: status };
            sendLog(data);
            if (status)
                return setIsStarted(true);
        }
        catch (err) { }
        setTimeout(() => meetingStarted(), 2000);
    };
    useEffect(() => {
        if (isWebview()) {
            setWebviewError(true);
            setLoaded(true);
            return;
        }
        (async () => {
            try {
                if (!organisation || !roomName)
                    return;
                const { data: { is_moderator: isModerator, room, status: isRoomAvailable }, } = await getMeetingData(organisation, roomName);
                if (!isRoomAvailable) {
                    setLoaded(true);
                    return;
                }
                window.APP.room = room;
                if (localStorage.getItem('isVconnect') === 'true') {
                    window.APP.room.vconnect = true;
                }
                if (localStorage.getItem('isVconnectCaller') === 'true')
                    window.APP.room.vconnectCaller = true;
                setRoom(room);
                localStorage.setItem('conference_options', JSON.stringify(room.conference_options));
                if (!user) {
                    meetingStarted();
                    setLoaded(true); // show waiting page for anonim users and start isStarted requests
                    return;
                }
                if (isModerator) {
                    window.APP.isModerator = true;
                    setIsStarted(true); // user is a moderator so start the meeting.
                }
                else {
                    meetingStarted();
                }
                setLoaded(true);
            }
            catch (err) {
                setLoaded(true);
                return;
            }
        })();
    }, []);
    if (!loaded) {
        return React.createElement(Loading, null);
    }
    else if (webviewError) {
        return React.createElement(WebviewError, { isMeetingPage: true });
    }
    else if (isStarted) {
        return React.createElement(App, { user: user });
    }
    else if (room === null) {
        return React.createElement(NotFound, { errorText: translateToHTML(t, 'notfoundpage.message') });
    }
    else if (localStorage.getItem('isVconnect') === 'true' && !isStarted) {
        //vconnect is already authenticated so rendering loader if no webview error
        return React.createElement(Loading, null);
    }
    return React.createElement(WaitingRoom, { room: room, user: user });
};
export default MeetingPage;
